import { useLocation, useNavigate } from "react-router-dom";
import Button from "./Common/Button";
import { ReactComponent as PopupConfigurationIcon } from "../assets/icons/popup-configuration.svg";
import { ReactComponent as CustomerManagementIcon } from "../assets/icons/customer-management.svg";

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCustomerManagementRoute = location?.pathname.startsWith("/customer-management");
  const isPopupConfigurationRoute = location?.pathname.startsWith("/popup-configuration");

  return (
    <div className="headerMenu basis-1/3 items-center lg:h-full fixed left-0 bottom-0 right-0 h-toolbar bg-white dark:bg-[#012359] lg:bg-transparent shadow-menufooter dark:shadow-headerMenuDarkTheme lg:dark:shadow-none lg:static lg:shadow-none">
      <div className="flex items-center justify-center max-[430px]:gap-2 gap-4 lg:gap-7 h-full">
        <Button
          className={`flex flex-col gap-1 justify-center items-center cursor-pointer basis-12 sm:basis-16 shrink-0 h-full ${isCustomerManagementRoute
              ? "border-theme border-b-2 active"
              : "border-dark-grey"
            }`}
          onClick={() => navigate("/customer-management")}
          aria-current={isCustomerManagementRoute ? "page" : undefined}
          data-testid="customer-management-nav-item"
        >
          <div
            className={`iconHolder ${
              isCustomerManagementRoute ? "text-theme" : "text-dark-grey dark:text-white"
            }`}
          >
            <CustomerManagementIcon />
          </div>
          <div
            className={` text-xs leading-5 font-medium tracking-[0.024px] ${isCustomerManagementRoute
                ? "text-theme"
                : "text-dark-grey dark:text-white"
              }`}
          >
            Customers
          </div>
        </Button>

        {/* Popup Configuration */}
        <Button
          className={`flex flex-col gap-1 justify-center items-center cursor-pointer basis-12 sm:basis-16 shrink-0 h-full ${isPopupConfigurationRoute
              ? "border-theme border-b-2 active"
              : "border-dark-grey"
            }`}
          onClick={() => navigate("/popup-configuration")}
          aria-current={isPopupConfigurationRoute ? "page" : undefined}
          data-testid="popup-configuration-nav-item"
        >
          <div
            className={`iconHolder ${
              isPopupConfigurationRoute ? "text-theme" : "text-dark-grey dark:text-white"
            }`}
          >
            <PopupConfigurationIcon />
          </div>
          <div
            className={` text-xs leading-5 font-medium tracking-[0.024px] ${isPopupConfigurationRoute
                ? "text-theme"
                : "text-dark-grey dark:text-white"
              }`}
          >
            Popups
          </div>
        </Button>
      </div>
    </div>
  )
}

export default NavBar;
